import { createSignal } from '@pexip/signal';
const SIGNAL_PREFIX = 'call:peerConnection:stats';
const REQUIRED_STATS_SIGNAL_KEYS = [
    'onRtcStats',
    'onCallQualityStats',
    'onCallQuality',
];
/**
 * Create and return all required and optional (if specified with `more`),
 * signals for infinity client to work
 *
 * @param scope - any scope prefix for the generated signal name, @see Signal
 * @param more - Keys from `InfinitySignalsOptional`, @see InfinitySignalsOptional
 *
 * The following signals created by default
 * - 'onConnected',
 * - 'onAnswer',
 *
 * @see REQUIRED_STATS_SIGNAL_KEYS
 */
export const createStatsSignals = (scope = '') => {
    const signalScope = scope && [scope, ':'].join('');
    return REQUIRED_STATS_SIGNAL_KEYS.reduce((signals, key) => ({
        // biome-ignore lint/performance/noAccumulatingSpread: runs once per collector over a fixed key list; `Object.fromEntries` would need a double cast to `StatsSignals`
        ...signals,
        [key]: createSignal({
            name: `${SIGNAL_PREFIX}:${signalScope}:${key}`,
            allowEmittingWithoutObserver: true,
        }),
    }), {});
};
//# sourceMappingURL=utils.js.map